import React from "react";
import Section from "../components/Section";

function YourRights() {
  return (
    <Section id="your-rights" icon="⚖️" title="Your Rights">
      <p>
        Depending on your location, you may have certain rights regarding your data:
      </p>
      <ul>
        <li><strong>Right to access</strong> — request a summary of data associated with your device.</li>
        <li><strong>Right to deletion</strong> — request deletion of data associated with your device identifier.</li>
        <li><strong>Right to opt out of analytics</strong> — you can disable analytics tracking by uninstalling the App.</li>
        <li><strong>Right to opt out of notifications</strong> — disable push notifications in your device settings at any time.</li>
      </ul>
      <p>
        Because we do not collect personal identifiers, we may not be able to associate a data deletion
        request with a specific individual. To submit a request, please contact us with your device
        identifier (found in App settings) so we can locate and remove the relevant records.
      </p>
    </Section>
  );
}

export default YourRights;
